import store from '@/store'
export default {
  getLocalRouters: function (localLists) {
    const that = this
    const localRouters = []
    const children = []
    localLists.forEach(item => {
      if ((item.meta) && (item.meta.link !== '')) {
        item.component = that.getViews(item.meta.link)
      }
      if (item.children) {
        that.reCursionLocalRouter(children, item)
        item.children = children
      }
      localRouters.push(item)
    })
    return localRouters
  },
  reCursionLocalRouter: function (children, item) {
    if (item.children) {
      item.children.forEach(e => {
        this.reCursionLocalRouter(children, e)
      })
    } else if ((item.meta) && (item.meta.link !== '')) {
      const view = this.getViews(item.meta.link)
      const nameComponent = {}
      nameComponent[item.meta.id] = view
      children.push({
        path: item.meta.link,
        name: item.meta.id,
        // component: view,
        components: nameComponent,
        meta: {
          link: item.meta.link,
          title: item.meta.title,
          id: item.meta.id,
          vuename: item.meta.vuename,
          paras: item.meta.paras,
          keeplive: item.meta.keeplive
        }
      })
      if ((item.meta.keeplive === true) && (item.meta.vuename !== '')) {
        store.commit('cacheTabs/setKeepAliveList', item.meta.vuename)
      }
    }
  },
  getRouters: function (menuList) {
    const children = []
    menuList.forEach(item => {
      this.reCursionRouter(children, item)
    })
    return children
  },
  reCursionRouter: function (children, item) {
    if (item.children) {
      item.children.forEach(e => {
        this.reCursionRouter(children, e)
      })
    } else if (item.r_mn_link !== '') {
      const view = this.getViews(item.r_mn_path)
      const nameComponent = {}
      nameComponent[item.r_mn_id] = view
      children.push({
        path: item.r_mn_link,
        name: item.r_mn_id,
        // component: view,
        components: nameComponent,
        meta: {
          link: item.r_mn_path,
          title: item.r_mn_desc,
          id: item.r_mn_id,
          vuename: item.r_vue_name,
          paras: item.r_mn_para,
          keeplive: item.r_keep_live
        }
      })
      if ((item.r_keep_live === true) && (item.r_vue_name !== '')) {
        store.commit('cacheTabs/setKeepAliveList', item.r_vue_name)
      }
    }
  },
  getView: function (path) {
    return (resolve) => require([path], resolve)
  },
  getViews: function (path) {
    return resolve => {
      require.ensure([], (require) => {
        resolve(require('@/' + path + '.vue'))
      })
    }
  },
  getMenuLists: function (menuLists, menuId) {
    var menu = {
      menu: {}
    }
    this.reCursionMenuLists(menuLists, menuId, menu)
    return menu.menu
  },
  reCursionMenuLists: function (children, menuId, menu) {
    if (JSON.stringify(menu.menu) !== '{}') {
      return
    }
    for (let i = 0; i < children.length; i++) {
      if (children[i].r_mn_id === menuId) {
        menu.menu = children[i]
        return
      } else if ((children[i].children) && (JSON.stringify(menu.menu) === '{}')) {
        this.reCursionMenuLists(children[i].children, menuId, menu)
        if (JSON.stringify(menu.menu) !== '{}') {
          return
        }
      }
    }
  }
}
